export const MODULE_NAME = 'marketplaceAdmin';
export const REDUCER_NAMESPACE = 'MARKETPLACE_ADMIN';
